// extracted by mini-css-extract-plugin
var _1 = "active";
var _2 = "align-bottom";
var _3 = "align-center";
var _4 = "align-justify";
var _5 = "align-left";
var _6 = "align-top";
var _7 = "boldtext";
var _8 = "buttonwidth";
var _9 = "capitalize";
var _a = "card";
var _b = "card-block";
var _c = "card-blocks";
var _d = "color-gray";
var _e = "container";
var _f = "content";
var _10 = "content-divider";
var _11 = "disabled";
var _12 = "focus";
var _13 = "heading-link";
var _14 = "hover";
var _15 = "in-dark-background";
var _16 = "input-state-help";
var _17 = "main";
var _18 = "margin-bot-xx-large";
var _19 = "margin-bot-zero";
var _1a = "margin-bottom";
var _1b = "margin-dropdowntop";
var _1c = "margin-hinttop";
var _1d = "margin-left-medium";
var _1e = "margin-top";
var _1f = "margin-top-small";
var _20 = "margin-top-x-large";
var _21 = "margin-top-xx-large";
var _22 = "margin-top-xx-small";
var _23 = "padding-bottom";
var _24 = "padding-left";
var _25 = "padding-top";
var _26 = "shorten-divider";
var _27 = "span-block";
var _28 = "spin";
var _29 = "tds-a";
var _2a = "tds-action-button-wrapper";
var _2b = "tds-alert--dismissible";
var _2c = "tds-alert--error";
var _2d = "tds-alert--has-inner-icon";
var _2e = "tds-alert--info";
var _2f = "tds-alert--success";
var _30 = "tds-alert--warning";
var _31 = "tds-alert-sitewide-layout";
var _32 = "tds-alert-sitewide-region";
var _33 = "tds-alert-sitewide__title";
var _34 = "tds-alert__dismiss";
var _35 = "tds-alert__inner-action";
var _36 = "tds-alert__inner-container";
var _37 = "tds-alert__inner-text";
var _38 = "tds-alert__title";
var _39 = "tds-app-alert--error";
var _3a = "tds-app-alert--has-inner-icon";
var _3b = "tds-app-alert--info";
var _3c = "tds-app-alert--success";
var _3d = "tds-app-alert--warning";
var _3e = "tds-app-alert-sitewide-layout";
var _3f = "tds-app-alert-sitewide-region";
var _40 = "tds-app-alert-sitewide__title";
var _41 = "tds-app-alert__inner-action";
var _42 = "tds-app-alert__inner-container";
var _43 = "tds-app-alert__inner-text";
var _44 = "tds-app-alert__title";
var _45 = "tds-app-wrapper";
var _46 = "tds-blockquote";
var _47 = "tds-body";
var _48 = "tds-bold";
var _49 = "tds-button";
var _4a = "tds-button--ghost";
var _4b = "tds-button--primary";
var _4c = "tds-button--secondary";
var _4d = "tds-button--small";
var _4e = "tds-button--tertiary";
var _4f = "tds-button-container";
var _50 = "tds-button__icon";
var _51 = "tds-button__icon--first";
var _52 = "tds-button__icon--last";
var _53 = "tds-check";
var _54 = "tds-check__description";
var _55 = "tds-container";
var _56 = "tds-container--full-width";
var _57 = "tds-container-fluid";
var _58 = "tds-desktop";
var _59 = "tds-fieldset";
var _5a = "tds-global-footer";
var _5b = "tds-global-footer-cap";
var _5c = "tds-global-footer__copy";
var _5d = "tds-global-footer__disclaimer";
var _5e = "tds-global-footer__link-group";
var _5f = "tds-global-footer__link-group-heading";
var _60 = "tds-global-footer__link-item";
var _61 = "tds-global-footer__links";
var _62 = "tds-global-footer__logo";
var _63 = "tds-global-footer__social";
var _64 = "tds-global-footer__social-item";
var _65 = "tds-global-footer__wrapper";
var _66 = "tds-global-header";
var _67 = "tds-global-header__actions-block";
var _68 = "tds-global-header__actions-item";
var _69 = "tds-global-header__identity";
var _6a = "tds-global-header__identity-block";
var _6b = "tds-global-header__identity-block--center";
var _6c = "tds-global-header__logo";
var _6d = "tds-global-header__menu-wrapper";
var _6e = "tds-global-header__product";
var _6f = "tds-global-header__wrapper";
var _70 = "tds-h1";
var _71 = "tds-h1--article";
var _72 = "tds-h1--large";
var _73 = "tds-h1--small";
var _74 = "tds-h2";
var _75 = "tds-h2--article";
var _76 = "tds-h2--link";
var _77 = "tds-h2--link-underline";
var _78 = "tds-h3";
var _79 = "tds-h3--article";
var _7a = "tds-h3--link";
var _7b = "tds-h3--link-underline";
var _7c = "tds-h4";
var _7d = "tds-h4--link";
var _7e = "tds-h4--link-underline";
var _7f = "tds-h4--navigation";
var _80 = "tds-h5";
var _81 = "tds-h5--error";
var _82 = "tds-h5--info";
var _83 = "tds-h5--link";
var _84 = "tds-h5--link-underline";
var _85 = "tds-h5--success";
var _86 = "tds-h5--warning";
var _87 = "tds-h6";
var _88 = "tds-h6--link";
var _89 = "tds-h6--link-underline";
var _8a = "tds-iconbutton";
var _8b = "tds-iconbutton--large";
var _8c = "tds-iconbutton--small";
var _8d = "tds-iconbutton--xlarge";
var _8e = "tds-iconbutton__icon";
var _8f = "tds-inline-alert--error";
var _90 = "tds-inline-alert--info";
var _91 = "tds-inline-alert--success";
var _92 = "tds-inline-alert--warning";
var _93 = "tds-inline-alert__title";
var _94 = "tds-input";
var _95 = "tds-italic";
var _96 = "tds-large";
var _97 = "tds-legend";
var _98 = "tds-li";
var _99 = "tds-list-inline";
var _9a = "tds-list-unstyled";
var _9b = "tds-mobile";
var _9c = "tds-nav";
var _9d = "tds-nav__toggle--menu";
var _9e = "tds-p";
var _9f = "tds-screen-readers-only";
var _a0 = "tds-screen-readers-only__focusable";
var _a1 = "tds-skip-link";
var _a2 = "tds-small";
var _a3 = "tds-sr-only";
var _a4 = "tds-sr-only__focusable";
var _a5 = "tds-ul";
var _a6 = "tds-x-small";
var _a7 = "type-color__gray-dark";
var _a8 = "type-color__gray-light";
var _a9 = "type-color__teal-dark";
var _aa = "type-color__white";
var _ab = "view-container-medium";
var _ac = "visited";
export { _1 as "active", _2 as "align-bottom", _3 as "align-center", _4 as "align-justify", _5 as "align-left", _6 as "align-top", _7 as "boldtext", _8 as "buttonwidth", _9 as "capitalize", _a as "card", _b as "card-block", _c as "card-blocks", _d as "color-gray", _e as "container", _f as "content", _10 as "content-divider", _11 as "disabled", _12 as "focus", _13 as "heading-link", _14 as "hover", _15 as "in-dark-background", _16 as "input-state-help", _17 as "main", _18 as "margin-bot-xx-large", _19 as "margin-bot-zero", _1a as "margin-bottom", _1b as "margin-dropdowntop", _1c as "margin-hinttop", _1d as "margin-left-medium", _1e as "margin-top", _1f as "margin-top-small", _20 as "margin-top-x-large", _21 as "margin-top-xx-large", _22 as "margin-top-xx-small", _23 as "padding-bottom", _24 as "padding-left", _25 as "padding-top", _26 as "shorten-divider", _27 as "span-block", _28 as "spin", _29 as "tds-a", _2a as "tds-action-button-wrapper", _2b as "tds-alert--dismissible", _2c as "tds-alert--error", _2d as "tds-alert--has-inner-icon", _2e as "tds-alert--info", _2f as "tds-alert--success", _30 as "tds-alert--warning", _31 as "tds-alert-sitewide-layout", _32 as "tds-alert-sitewide-region", _33 as "tds-alert-sitewide__title", _34 as "tds-alert__dismiss", _35 as "tds-alert__inner-action", _36 as "tds-alert__inner-container", _37 as "tds-alert__inner-text", _38 as "tds-alert__title", _39 as "tds-app-alert--error", _3a as "tds-app-alert--has-inner-icon", _3b as "tds-app-alert--info", _3c as "tds-app-alert--success", _3d as "tds-app-alert--warning", _3e as "tds-app-alert-sitewide-layout", _3f as "tds-app-alert-sitewide-region", _40 as "tds-app-alert-sitewide__title", _41 as "tds-app-alert__inner-action", _42 as "tds-app-alert__inner-container", _43 as "tds-app-alert__inner-text", _44 as "tds-app-alert__title", _45 as "tds-app-wrapper", _46 as "tds-blockquote", _47 as "tds-body", _48 as "tds-bold", _49 as "tds-button", _4a as "tds-button--ghost", _4b as "tds-button--primary", _4c as "tds-button--secondary", _4d as "tds-button--small", _4e as "tds-button--tertiary", _4f as "tds-button-container", _50 as "tds-button__icon", _51 as "tds-button__icon--first", _52 as "tds-button__icon--last", _53 as "tds-check", _54 as "tds-check__description", _55 as "tds-container", _56 as "tds-container--full-width", _57 as "tds-container-fluid", _58 as "tds-desktop", _59 as "tds-fieldset", _5a as "tds-global-footer", _5b as "tds-global-footer-cap", _5c as "tds-global-footer__copy", _5d as "tds-global-footer__disclaimer", _5e as "tds-global-footer__link-group", _5f as "tds-global-footer__link-group-heading", _60 as "tds-global-footer__link-item", _61 as "tds-global-footer__links", _62 as "tds-global-footer__logo", _63 as "tds-global-footer__social", _64 as "tds-global-footer__social-item", _65 as "tds-global-footer__wrapper", _66 as "tds-global-header", _67 as "tds-global-header__actions-block", _68 as "tds-global-header__actions-item", _69 as "tds-global-header__identity", _6a as "tds-global-header__identity-block", _6b as "tds-global-header__identity-block--center", _6c as "tds-global-header__logo", _6d as "tds-global-header__menu-wrapper", _6e as "tds-global-header__product", _6f as "tds-global-header__wrapper", _70 as "tds-h1", _71 as "tds-h1--article", _72 as "tds-h1--large", _73 as "tds-h1--small", _74 as "tds-h2", _75 as "tds-h2--article", _76 as "tds-h2--link", _77 as "tds-h2--link-underline", _78 as "tds-h3", _79 as "tds-h3--article", _7a as "tds-h3--link", _7b as "tds-h3--link-underline", _7c as "tds-h4", _7d as "tds-h4--link", _7e as "tds-h4--link-underline", _7f as "tds-h4--navigation", _80 as "tds-h5", _81 as "tds-h5--error", _82 as "tds-h5--info", _83 as "tds-h5--link", _84 as "tds-h5--link-underline", _85 as "tds-h5--success", _86 as "tds-h5--warning", _87 as "tds-h6", _88 as "tds-h6--link", _89 as "tds-h6--link-underline", _8a as "tds-iconbutton", _8b as "tds-iconbutton--large", _8c as "tds-iconbutton--small", _8d as "tds-iconbutton--xlarge", _8e as "tds-iconbutton__icon", _8f as "tds-inline-alert--error", _90 as "tds-inline-alert--info", _91 as "tds-inline-alert--success", _92 as "tds-inline-alert--warning", _93 as "tds-inline-alert__title", _94 as "tds-input", _95 as "tds-italic", _96 as "tds-large", _97 as "tds-legend", _98 as "tds-li", _99 as "tds-list-inline", _9a as "tds-list-unstyled", _9b as "tds-mobile", _9c as "tds-nav", _9d as "tds-nav__toggle--menu", _9e as "tds-p", _9f as "tds-screen-readers-only", _a0 as "tds-screen-readers-only__focusable", _a1 as "tds-skip-link", _a2 as "tds-small", _a3 as "tds-sr-only", _a4 as "tds-sr-only__focusable", _a5 as "tds-ul", _a6 as "tds-x-small", _a7 as "type-color__gray-dark", _a8 as "type-color__gray-light", _a9 as "type-color__teal-dark", _aa as "type-color__white", _ab as "view-container-medium", _ac as "visited" }
